function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("path", {
  d: "M6.141 8.733L8 10.653V1.625a1 1 0 112 0v9.028l1.858-1.92a1.016 1.016 0 011.462 1.412l-3.915 4.06a.562.562 0 01-.81 0l-3.915-4.06a1.016 1.016 0 011.461-1.412z",
  fill: "#057CCC"
}), React.createElement("path", {
  d: "M16 11.188c0-.311.252-.563.563-.563h.875c.31 0 .562.252.562.563v5.562c0 .962-.9 1.75-2 1.75H2c-1.1 0-2-.788-2-1.75v-5.563c0-.31.252-.562.563-.562h.875c.31 0 .562.252.562.563v5c0 .31.252.562.563.562h12.874c.311 0 .563-.252.563-.563v-5z",
  fill: "#057CCC"
})));